import React from "react";
import { useState } from "react";
import * as FaIcons from "react-icons/fa";
import "./Navbar.scss";

function Navbar() {
  const [toggle, setToggle] = useState(false);
  const showSideBar = () => {
    setToggle(!toggle);
  };
  return (
    <div className="navbar">
      <div className="navbar_container">
        <a href="/" className="navbar_logo" onClick={() => setToggle(false)}>
          <h5>
            <span> {"</"} </span> Emeka
          </h5>
        </a>
        <ul
          className={toggle ? "navlist active" : "navlist"}
          // style={{ display: toggle ? "" : "none" }}
        >
          <li
            onClick={() => setToggle(false)}
            // style={{ display: toggle ? "block" : "none" }}
          >
            <a href="#about">About</a>
          </li>
          <li
            onClick={() => setToggle(false)}
            // style={{ display: toggle ? "block" : "none" }}
          >
            <a href="#skills">Skills</a>
          </li>
          <li
            onClick={() => setToggle(false)}
            // style={{ display: toggle ? "block" : "none" }}
          >
            <a href="#portfolio">Portfolio</a>
          </li>
          <div
            className="contact_button"
            onClick={() => setToggle(false)}
            // style={{ display: toggle ? "block" : "none" }}
          >
            <a href="#contact">Contact Me {"/>"}</a>
          </div>
        </ul>
        <div className="hamburger" onClick={showSideBar}>
          {toggle ? <FaIcons.FaTimes /> : <FaIcons.FaBars />}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
